// extracted by mini-css-extract-plugin
export default {"message":"styles_message__pZx8a"};